var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEpisodes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8281 20.9858H27.2448C27.9962 20.9858 28.7169 20.7224 29.2483 20.2535C29.7796 19.7847 30.0781 19.1488 30.0781 18.4858V7.23578C30.0781 6.57274 29.7796 5.93685 29.2483 5.46801C28.7169 4.99917 27.9962 4.73578 27.2448 4.73578H14.4948C13.7433 4.73578 13.0227 4.99917 12.4913 5.46801C11.96 5.93685 11.6615 6.57274 11.6615 7.23578V8.48578",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8281 20.9858H27.2448C27.9962 20.9858 28.7169 20.7224 29.2483 20.2535C29.7796 19.7847 30.0781 19.1488 30.0781 18.4858V7.23578C30.0781 6.57274 29.7796 5.93685 29.2483 5.46801C28.7169 4.99917 27.9962 4.73578 27.2448 4.73578H14.4948C13.7433 4.73578 13.0227 4.99917 12.4913 5.46801C11.96 5.93685 11.6615 6.57274 11.6615 7.23578V8.48578",
    stroke: "#282279",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4224 24.592H22.839C23.5905 24.592 24.3111 24.3286 24.8425 23.8598C25.3739 23.391 25.6724 22.7551 25.6724 22.092V10.842C25.6724 10.179 25.3739 9.54311 24.8425 9.07427C24.3111 8.60543 23.5905 8.34204 22.839 8.34204H10.089C9.33758 8.34204 8.61691 8.60543 8.08556 9.07427C7.55421 9.54311 7.2557 10.179 7.2557 10.842V12.092",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4224 24.592H22.839C23.5905 24.592 24.3111 24.3286 24.8425 23.8598C25.3739 23.391 25.6724 22.7551 25.6724 22.092V10.842C25.6724 10.179 25.3739 9.54311 24.8425 9.07427C24.3111 8.60543 23.5905 8.34204 22.839 8.34204H10.089C9.33758 8.34204 8.61691 8.60543 8.08556 9.07427C7.55421 9.54311 7.2557 10.179 7.2557 10.842V12.092",
    stroke: "#282279",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4168 11.6192H5.66683C4.10202 11.6192 2.8335 12.7385 2.8335 14.1192V25.3692C2.8335 26.7499 4.10202 27.8692 5.66683 27.8692H18.4168C19.9816 27.8692 21.2502 26.7499 21.2502 25.3692V14.1192C21.2502 12.7385 19.9816 11.6192 18.4168 11.6192Z",
    fill: "white",
    stroke: "#282279",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpisodes);
export default __webpack_public_path__ + "static/media/EPISODES.0a61f8b14e1721253344d59267db7018.svg";
export { ForwardRef as ReactComponent };